<template>
<div class="formAdd">
    <div class="field">
  <label class="label ">Nama Produk</label>
  <div class="control has-icons-left">
    <input class="input" type="text" placeholder="Input Nama Product" v-model="dataEdit.name">
  <span class="icon is-small is-left">
      <i class="fa fa-archive" aria-hidden="true"></i>
  </span>
  </div>
</div>

<div class="field">
  <label class="label">Foto Produk</label>
  <div class="control has-icons-left">
    <input class="input" type="url" placeholder="URL Foto Produk" v-model="dataEdit.image_url">
    <span class="icon is-small is-left">
<i class="fas fa-images"></i>
    </span>
  </div>

</div>
<div class="field">
  <label class="label">Harga Barang</label>
  <div class="control has-icons-left">
    <input class="input" type="number" placeholder="Harga Barang" v-model="dataEdit.price">
    <span class="icon is-small is-left">
      <i class="fas fa-money-bill"></i>
    </span>
  </div>
</div>

<div class="field">
  <label class="label">Stock Barang</label>
  <div class="control has-icons-left">
    <input class="input" type="number" placeholder="Stock Barang" v-model="dataEdit.stock">
    <span class="icon is-small is-left">
      <i class="fas fa-boxes"></i>
    </span>
  </div>
</div>
<div class="field is-grouped">
  <div class="control">
    <button class="button is-link" @click="editProduct()">Submit</button>
  </div>
  <div class="control">
    <button class="button is-link is-light" @click="allProduct()">Cancel</button>
  </div>
</div>
</div>
</template>
<script>
import axios from '../../axios.config'
export default {
  data () {
    return {
      id: this.$route.params.id,
      editData: ''
    }
  },
  methods: {
    allProduct () {
      this.$router.push('/all-product')
    },
    editProduct () {
      let payload = {
          name: this.dataEdit.name,
          price: this.dataEdit.price,
          image_url: this.dataEdit.image_url,
          stock: this.dataEdit.stock,
          id:this.id
      }
      this.$store.dispatch('editProduct', payload)
      this.$router.push('/all-product')
    }
  },
  computed:{
    dataEdit (){
      return this.$store.state.editData
    }
  },
  created () {
    this.$store.dispatch('findOne',this.id)
  }
}
</script>

<style>
.formAdd{
    width: 400px;
    justify-content: center;
    text-align: center;
    background-color: rgb(245, 226, 241);
    margin-left: 250px;
    margin-bottom: 50px;
}
</style>